import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AUIModal } from '@ancert/aui-modal';
import { ReactComponent as IconWarning } from '../../../../assets/images/ic-warning.svg';
import './ModalErrorValidacion.scss';

/**
 * Modal para mostrar error en la validación de firma
 * @param {Object} props - Props del componente
 * @param {boolean} props.show - Controla si el modal está visible
 * @param {function} props.onClose - Función para cerrar el modal
 * @returns {React.ReactElement} - Componente ModalErrorValidacion
 */
const ModalErrorValidacion = ({ show, onClose }) => {
  const { t } = useTranslation();
  return (
  <AUIModal
    autoHeight
    size="sm"
    show={show}
    className="modal-error-validacion"
    actionButtons={[
      {
        id: 'tertiary',
        mode: 'tertiary',
        label: t('backButton'),
        onClick: onClose,
        disabled: false,
      },
    ]}
    onClose={onClose}
  >
    <div className="modal-content">
      <IconWarning />
      <p><b>{t('modalErrorValidacion.title')}</b></p>
      <br />
      <p>{t('modalErrorValidacion.desc')}</p>
    </div>
  </AUIModal>
);
};

ModalErrorValidacion.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalErrorValidacion;
